import { toggleShowLevel2Modifier } from '../toggle_show_level_2_modifier';
import { toggleShowLevel2 } from './toggle_show_level_2';
import getTranslatedText from '../../../_flux/helper/get_translated_text';
import * as GAEvents from '../../google_analytics/navigation';

export const resetLevel2 = ($nav, setCurrentNavLabel) => {
    const defaultCurrentNavLabel = getTranslatedText('navigation-level-1-opened-current-nav-label');
    setCurrentNavLabel(defaultCurrentNavLabel);
    toggleShowLevel2Modifier($nav, undefined, false);
    toggleShowLevel2($nav.find('.navigation-level-2--opened'), false);
    GAEvents.backToFirstLevel();
};
